import { Box, Button } from "@material-ui/core";
import React from "react";
import { NumberField } from "react-admin";
import {
  Datagrid,
  Edit as EditAdmin,
  EditButton,
  ReferenceManyField,
  Show,
  TextField,
  TopToolbar,
} from "react-admin";
import { Link, useLocation } from "react-router-dom";
import { Form } from "./Create";
import ListActions from "./ListActions";

const PeriodShowActions = ({ id }: any) => (
  <TopToolbar>
    <Button
      className="MuiButton-textPrimary MuiButton-textSizeSmall"
      component={Link}
      to={{
        pathname: "/periods/create",
        state: { record: { gradeId: parseInt(id) } },
      }}
    >
      + Create
    </Button>
  </TopToolbar>
);

const PeriodShow = (props: any) => {
  return (
    <Show {...props} actions={<PeriodShowActions {...props} />} title={" "}>
      <ReferenceManyField
        label="periods"
        reference="periods"
        target="gradeId"
        perPage={1000}
        sort={{ field: "id", order: "ASC" }}
      >
        <Datagrid>
          <TextField source="name" label="Tên kỳ" />
          <EditButton />
        </Datagrid>
      </ReferenceManyField>
    </Show>
  );
};

const Edit = (props: any) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const mode = params.get("mode");
  return (
    <div style={{ flex: 1, display: "flex" }}>
      <Box flex={2} ml={{ xs: 0, sm: "0.5em" }}>
        <EditAdmin
          undoable={false}
          component="div"
          {...props}
          actions={<ListActions mode={mode} />}
        >
          <Form />
        </EditAdmin>
      </Box>
      <Box flex={2} ml={{ xs: 0, sm: "0.5em" }}>
        <PeriodShow {...props} />
      </Box>
    </div>
  );
};

export default Edit;
